export const siteSettings = {
  name: "Trade View",
  link: "https://defiradar.net",
  email: "support@defiradar.net",
  appLink: "https://app.defiradar.net",
};
